@if ({ bestPerformingLists: bestPerformingLists$ | async, bestListMinDate:
bestListMinDate$ | async, currentUserExternalId: currentUserExternalId$ | async,
loading: loading$ | async, hasError: hasError$ | async, exchange: exchange$ |
async }; as ctx) {
<div class="dashboard">
  <epc-dashboard-header-controls
    [minDate]="ctx.bestListMinDate"
    [brandOrgs]="brandOrgFilter$ | async"
    [selectedBrandOrgsIds]="selectedBrandOrgIds$ | async"
    [isBrandFilterAvailable]="brandOrgsFilterEnabled$ | async"
    [preselectedDateRangeFilterValue]="preselectedDateRangeFilterValue$ | async"
    [preselectedBrandOrg]="preselectedBrandOrg$ | async"
    (updateParams)="setStoreParams($event)"
  ></epc-dashboard-header-controls>
  @if ( !ctx.loading && (ctx.hasError || ctx.bestPerformingLists.length === 0) )
  {
  <epc-dashboard-empty-state
    [hasFiltersSelected]="(this.selectedBrandOrgIds$ | async)?.length"
    (clearFilters)="
      setStoreParams({
        brandOrgIds: []
      })
    "
  ></epc-dashboard-empty-state>
  } @if ( (!ctx.hasError && ctx.loading && ctx.bestPerformingLists.length === 0)
  || ctx.bestPerformingLists.length > 0 ) {
  <epc-dashboard-table
    [bestLists]="ctx.bestPerformingLists"
    [currentUserExternalId]="ctx.currentUserExternalId"
    [exchange]="ctx.exchange"
    [isLoading]="ctx.loading"
    [showHotIconBadges]="showHotIconBadges$ | async"
    (listSelect)="onListSelect($event)"
  ></epc-dashboard-table>
  }
</div>
}
